import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectSortBy, setSortBy } from '../../redux/sortByReducer';
import { SortByWrapper, Label, SortSelector, Option } from './SortBy.style';
import useFilterOptions from '../../hooks/useFilterOptions';

const SortBy: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { sortBy } = useSelector(selectSortBy);

  const { sortMethods } = useFilterOptions();

  const listOfSortMethods = Object.keys(sortMethods);

  return (
    <SortByWrapper data-testid="sort-by">
      <Label>{t('vlp.vehicleResults.sort.sortPrompt')}</Label>
      <SortSelector
        aria-label="sort by selector"
        value={sortBy}
        onChange={(e) => {
          dispatch(setSortBy(e.target.value));
        }}
      >
        {listOfSortMethods.map((option) => (
          <Option key={option} value={sortMethods[option as keyof typeof sortMethods]?.value}>
            {sortMethods[option as keyof typeof sortMethods]?.label}
          </Option>
        ))}
      </SortSelector>
    </SortByWrapper>
  );
};

export default SortBy;
